(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tabbed-sale-page"] && !Shopify.designMode) return;
  try {
    (() => {
    const ROOT_SELECTOR = '[data-tsp-root]';

    function formatMoney(cents, format) {
      const value = Number(cents || 0);
      const moneyFormat = format || '$__AMOUNT__';

      function withDelimiter(number, precision, thousands, decimal) {
        const fixed = (number / 100).toFixed(precision);
        const parts = fixed.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
      }

      let replacement = withDelimiter(value, 2, ',', '.');
      if (moneyFormat.includes('amount_no_decimals_with_comma_separator')) {
        replacement = withDelimiter(value, 0, '.', ',');
      } else if (moneyFormat.includes('amount_with_comma_separator')) {
        replacement = withDelimiter(value, 2, '.', ',');
      } else if (moneyFormat.includes('amount_no_decimals')) {
        replacement = withDelimiter(value, 0, ',', '.');
      }

      if (moneyFormat.includes('__AMOUNT__')) return moneyFormat.replace('__AMOUNT__', replacement);
      return moneyFormat.replace(/\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator)\s*\}\}/, replacement);
    }

    function initialise(root) {
      if (!root || root.dataset.tspInitialised === 'true') return;
      root.dataset.tspInitialised = 'true';

      const categoryConfigs = Array.from(root.querySelectorAll('[data-tsp-category-config]'));
      const tabsHost = root.querySelector('[data-tsp-main-tabs]');
      const subcategoryTrack = root.querySelector('[data-tsp-subcategory-track]');
      const productsStage = root.querySelector('[data-tsp-products-stage]');
      const heading = root.querySelector('[data-tsp-heading]');
      const description = root.querySelector('[data-tsp-description]');
      const defaultDescriptionTemplate = root.querySelector('[data-tsp-default-description-template]');
      const sortSelect = root.querySelector('[data-tsp-sort]');
      const countTarget = root.querySelector('[data-tsp-visible-count]');
      const filterDrawer = root.querySelector('[data-tsp-filter-drawer]');
      const productTypesHost = root.querySelector('[data-tsp-product-types]');
      const sizesHost = root.querySelector('[data-tsp-sizes]');
      const colorsHost = root.querySelector('[data-tsp-colors]');
      const fabricsHost = root.querySelector('[data-tsp-fabrics]');
      const priceMinInput = root.querySelector('[data-tsp-price-min]');
      const priceMaxInput = root.querySelector('[data-tsp-price-max]');
      const priceHint = root.querySelector('[data-tsp-price-hint]');
      const inStockInput = root.querySelector('[data-tsp-in-stock]');
      const filterDot = root.querySelector('[data-tsp-filter-dot]');
      const activeFilters = root.querySelector('[data-tsp-active-filters]');
      const quickBuy = root.querySelector('[data-tsp-quick-buy]');
      const quickBuyContent = root.querySelector('[data-tsp-quick-buy-content]');
      const defaultHeading = heading ? heading.textContent.trim() : '';
      let currentCategory = null;
      let currentSubcategories = [];
      let categoryFilterMode = 'product-type';
      let currentGrid = null;
      let currentProductList = null;
      let currentLoadSentinel = null;
      let currentLoadStatus = null;
      let loadMoreObserver = null;
      let loadMoreTimer = null;
      let loadedProductLimit = Math.max(1, Number(root.dataset.tspInitialProducts || 24));
      const initialProductCount = Math.max(1, Number(root.dataset.tspInitialProducts || 24));
      const loadBatchSize = Math.max(1, Number(root.dataset.tspLoadBatch || 24));
      const configuredMaximum = String(root.dataset.tspMaxProducts || 'all').toLowerCase();
      const maximumProductCount = configuredMaximum === 'all'
        ? Number.POSITIVE_INFINITY
        : Math.max(initialProductCount, Number(configuredMaximum || initialProductCount));

      function restoreDescription(config) {
        const categoryHeading = config?.dataset.heading || '';
        if (heading) {
          heading.textContent = categoryHeading || defaultHeading;
          heading.hidden = !heading.textContent.trim();
        }

        if (!description) return;
        const categoryTemplate = config?.querySelector('[data-tsp-category-description-template]');
        if (categoryTemplate) {
          description.innerHTML = categoryTemplate.innerHTML;
        } else if (defaultDescriptionTemplate) {
          description.innerHTML = defaultDescriptionTemplate.innerHTML;
        } else {
          description.innerHTML = '';
        }
      }

      function buildTabs() {
        if (!tabsHost) return;
        tabsHost.innerHTML = '';

        categoryConfigs.forEach((config, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'tsp-main-tab';
          button.dataset.categoryIndex = String(index);
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-selected', 'false');
          button.textContent = config.dataset.label || `Category ${index + 1}`;
          tabsHost.appendChild(button);
        });
      }

      function parseFacetList(value) {
        return String(value || '')
          .split('||')
          .map((item) => item.trim())
          .filter(Boolean);
      }

      function uniqueSorted(values) {
        return values
          .filter(Boolean)
          .filter((value, index, array) => array.indexOf(value) === index)
          .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }));
      }

      function normaliseSizeLabel(value) {
        return String(value || '')
          .trim()
          .toUpperCase()
          .replace(/[–—]/g, '-')
          .replace(/\s+/g, '')
          .replace(/^EXTRASMALL$/, 'XS')
          .replace(/^SMALL$/, 'S')
          .replace(/^MEDIUM$/, 'M')
          .replace(/^LARGE$/, 'L')
          .replace(/^EXTRALARGE$/, 'XL');
      }

      function sizeSortRank(value) {
        const size = normaliseSizeLabel(value);
        const aliases = {
          'XXXXS': 0, '4XS': 0,
          'XXXS': 1, '3XS': 1,
          'XXS': 2, '2XS': 2,
          'XS': 3,
          'XS-S': 3.5,
          'S': 4,
          'S-M': 4.5,
          'M': 5,
          'M-L': 5.5,
          'L': 6,
          'L-XL': 6.5,
          'XL': 7, '1XL': 7,
          'XL-XXL': 7.5, 'XL-2XL': 7.5,
          'XXL': 8, '2XL': 8,
          '2XL-3XL': 8.5, 'XXL-XXXL': 8.5,
          'XXXL': 9, '3XL': 9,
          '3XL-4XL': 9.5,
          'XXXXL': 10, '4XL': 10,
          '5XL': 11,
          '6XL': 12,
          '7XL': 13,
          '8XL': 14,
          'FREE': 90, 'FREESIZE': 90, 'ONE SIZE': 90, 'ONESIZE': 90
        };

        if (Object.prototype.hasOwnProperty.call(aliases, size)) return aliases[size];

        const numericMatch = size.match(/^([0-9]+(?:\.[0-9]+)?)(?:-([0-9]+(?:\.[0-9]+)?))?$/);
        if (numericMatch) return 100 + Number(numericMatch[1]);

        const ageMatch = size.match(/^([0-9]+)(?:Y|YR|YRS|YEAR|YEARS)$/);
        if (ageMatch) return 200 + Number(ageMatch[1]);

        return 1000;
      }

      function sortSizes(values) {
        return values
          .filter(Boolean)
          .filter((value, index, array) => array.indexOf(value) === index)
          .sort((a, b) => {
            const rankDifference = sizeSortRank(a) - sizeSortRank(b);
            if (rankDifference !== 0) return rankDifference;
            return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
          });
      }

      function selectedValues(host, selector) {
        if (!host) return [];
        return Array.from(host.querySelectorAll(`${selector}:checked`)).map((input) => input.value);
      }

      function inferSwatchColor(label) {
        const value = String(label || '').trim().toLowerCase();
        const colourMap = {
          beige: '#d8c3a5', black: '#111111', blue: '#4f77a8', brown: '#7b543d', burgundy: '#7b1e35',
          cream: '#f3ead3', gold: '#d4af37', green: '#62866b', grey: '#9a9a9a', gray: '#9a9a9a',
          ivory: '#f4f0df', khaki: '#b7a66a', lavender: '#b8a7d9', maroon: '#7a263a', mustard: '#c49a22',
          navy: '#223a5e', olive: '#6f7642', orange: '#d9823b', peach: '#efb39b', pink: '#d99aaf',
          purple: '#735184', red: '#b84343', rust: '#a65335', silver: '#c8c8c8', tan: '#b88b62',
          teal: '#3c8582', white: '#ffffff', wine: '#6f243b', yellow: '#e1c74e'
        };
        const match = Object.keys(colourMap).find((name) => value.includes(name));
        return match ? colourMap[match] : '#f2f2f2';
      }

      function createFacetOption(host, value, kind, displayLabel) {
        if (!host || !value) return;
        const label = document.createElement('label');
        label.className = 'tsp-filter-check';

        const input = document.createElement('input');
        input.type = 'checkbox';
        input.value = value;
        input.dataset.tspFacetFilter = kind;

        label.appendChild(input);

        if (kind === 'color') {
          const dot = document.createElement('span');
          dot.className = 'tsp-filter-color-dot';
          dot.style.backgroundColor = inferSwatchColor(value);
          label.appendChild(dot);
        }

        const text = document.createElement('span');
        text.textContent = displayLabel || value;
        label.appendChild(text);
        host.appendChild(label);
      }

      function setGroupVisibility(kind, visible) {
        const group = root.querySelector(`[data-tsp-filter-group="${kind}"]`);
        if (group) group.hidden = !visible;
      }

      function resetFilters() {
        if (inStockInput) inStockInput.checked = false;
        root.querySelectorAll('[data-tsp-facet-filter]').forEach((input) => {
          input.checked = false;
        });
        if (priceMinInput) priceMinInput.value = '';
        if (priceMaxInput) priceMaxInput.value = '';
        if (sortSelect) sortSelect.value = 'featured';
        loadedProductLimit = initialProductCount;
        applySortAndFilters();
      }

      function buildFilters() {
        if (!currentGrid) return;
        const cards = Array.from(currentGrid.querySelectorAll('[data-tsp-product-card]'));

        const configuredCategories = [];
        const configuredHandles = new Set();

        currentSubcategories.forEach((subcategory) => {
          const handle = String(subcategory.dataset.handle || '').trim();
          const label = String(subcategory.dataset.title || '').trim();
          const isSelected = subcategory.dataset.collectionSelected === 'true';
          const isEnabled = subcategory.dataset.showInCategoryFilter !== 'false';
          const isBroadCollection = /^(shop\s*all|all(?:\s+sale|\s+men|\s+women|\s+products)?)$/i.test(label);

          if (!handle || !label || !isSelected || !isEnabled || isBroadCollection || configuredHandles.has(handle)) return;
          configuredHandles.add(handle);
          configuredCategories.push({ handle, label });
        });

        const fallbackTypes = uniqueSorted(cards.map((card) => card.dataset.productType || ''));
        const sizes = sortSizes(cards.flatMap((card) => parseFacetList(card.dataset.sizes)));
        const colors = uniqueSorted(cards.flatMap((card) => parseFacetList(card.dataset.colors)));
        const fabrics = uniqueSorted(cards.flatMap((card) => parseFacetList(card.dataset.fabrics)));

        const hosts = [productTypesHost, sizesHost, colorsHost, fabricsHost];
        hosts.forEach((host) => {
          if (host) host.innerHTML = '';
        });

        if (configuredCategories.length > 0) {
          categoryFilterMode = 'collection';
          configuredCategories.forEach((category) => {
            createFacetOption(productTypesHost, category.handle, 'product-type', category.label);
          });
        } else {
          categoryFilterMode = 'product-type';
          fallbackTypes.forEach((value) => createFacetOption(productTypesHost, value, 'product-type'));
        }

        sizes.forEach((value) => createFacetOption(sizesHost, value, 'size'));
        colors.forEach((value) => createFacetOption(colorsHost, value, 'color'));
        fabrics.forEach((value) => createFacetOption(fabricsHost, value, 'fabric'));

        setGroupVisibility('product-type', configuredCategories.length > 0 || fallbackTypes.length > 0);
        setGroupVisibility('size', sizes.length > 0);
        setGroupVisibility('color', colors.length > 0);
        setGroupVisibility('fabric', fabrics.length > 0);

        const prices = cards.map((card) => Number(card.dataset.price || 0)).filter((price) => Number.isFinite(price) && price >= 0);
        if (prices.length > 0) {
          const minimum = Math.floor(Math.min(...prices) / 100);
          const maximum = Math.ceil(Math.max(...prices) / 100);
          if (priceMinInput) {
            priceMinInput.min = String(minimum);
            priceMinInput.max = String(maximum);
            priceMinInput.placeholder = String(minimum);
          }
          if (priceMaxInput) {
            priceMaxInput.min = String(minimum);
            priceMaxInput.max = String(maximum);
            priceMaxInput.placeholder = String(maximum);
          }
          if (priceHint) {
            priceHint.textContent = `${formatMoney(minimum * 100, root.dataset.moneyFormat)} – ${formatMoney(maximum * 100, root.dataset.moneyFormat)}`;
          }
          setGroupVisibility('price', true);
        } else {
          setGroupVisibility('price', false);
        }
      }

      function updateLoadMoreState(totalMatching, displayedCount) {
        const cappedTotal = Math.min(totalMatching, maximumProductCount);
        const hasMore = displayedCount < cappedTotal;

        if (currentLoadSentinel) currentLoadSentinel.hidden = !hasMore;
        if (currentLoadStatus && !hasMore) currentLoadStatus.hidden = true;

        if (loadMoreObserver && currentLoadSentinel) {
          loadMoreObserver.unobserve(currentLoadSentinel);
          if (hasMore) loadMoreObserver.observe(currentLoadSentinel);
        }
      }

      function applySortAndFilters() {
        if (!currentGrid) {
          if (countTarget) countTarget.textContent = '0';
          return;
        }

        const cards = Array.from(currentGrid.querySelectorAll('[data-tsp-product-card]'));
        const selectedTypes = selectedValues(productTypesHost, '[data-tsp-facet-filter="product-type"]');
        const selectedSizes = selectedValues(sizesHost, '[data-tsp-facet-filter="size"]');
        const selectedColors = selectedValues(colorsHost, '[data-tsp-facet-filter="color"]');
        const selectedFabrics = selectedValues(fabricsHost, '[data-tsp-facet-filter="fabric"]');
        const inStockOnly = Boolean(inStockInput?.checked);
        const minPrice = priceMinInput?.value === '' ? null : Number(priceMinInput.value) * 100;
        const maxPrice = priceMaxInput?.value === '' ? null : Number(priceMaxInput.value) * 100;

        cards.forEach((card) => {
          const cardSizes = parseFacetList(card.dataset.sizes);
          const cardColors = parseFacetList(card.dataset.colors);
          const cardFabrics = parseFacetList(card.dataset.fabrics);
          const cardCollectionHandles = parseFacetList(card.dataset.collectionHandles);
          const price = Number(card.dataset.price || 0);

          const typeMatch = selectedTypes.length === 0 || (
            categoryFilterMode === 'collection'
              ? selectedTypes.some((value) => cardCollectionHandles.includes(value))
              : selectedTypes.includes(card.dataset.productType || '')
          );
          const sizeMatch = selectedSizes.length === 0 || selectedSizes.some((value) => cardSizes.includes(value));
          const colorMatch = selectedColors.length === 0 || selectedColors.some((value) => cardColors.includes(value));
          const fabricMatch = selectedFabrics.length === 0 || selectedFabrics.some((value) => cardFabrics.includes(value));
          const stockMatch = !inStockOnly || card.dataset.available === 'true';
          const minMatch = minPrice === null || price >= minPrice;
          const maxMatch = maxPrice === null || price <= maxPrice;

          card.dataset.tspFilterMatch = typeMatch && sizeMatch && colorMatch && fabricMatch && stockMatch && minMatch && maxMatch
            ? 'true'
            : 'false';
        });

        const sortValue = sortSelect?.value || 'featured';
        cards.sort((a, b) => {
          if (sortValue === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
          if (sortValue === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
          if (sortValue === 'title-asc') return (a.dataset.title || '').localeCompare(b.dataset.title || '');
          if (sortValue === 'title-desc') return (b.dataset.title || '').localeCompare(a.dataset.title || '');
          if (sortValue === 'newest') return Number(b.dataset.created) - Number(a.dataset.created);
          if (sortValue === 'oldest') return Number(a.dataset.created) - Number(b.dataset.created);
          return Number(a.dataset.index) - Number(b.dataset.index);
        });

        cards.forEach((card) => currentGrid.appendChild(card));

        const matchingCards = cards.filter((card) => card.dataset.tspFilterMatch === 'true');
        const allowedCount = Math.min(loadedProductLimit, maximumProductCount, matchingCards.length);
        let displayedCount = 0;

        cards.forEach((card) => {
          const shouldDisplay = card.dataset.tspFilterMatch === 'true' && displayedCount < allowedCount;
          card.hidden = !shouldDisplay;
          if (shouldDisplay) displayedCount += 1;
        });

        if (countTarget) countTarget.textContent = String(Math.min(matchingCards.length, maximumProductCount));

        const filterActive = inStockOnly
          || selectedTypes.length > 0
          || selectedSizes.length > 0
          || selectedColors.length > 0
          || selectedFabrics.length > 0
          || minPrice !== null
          || maxPrice !== null;
        if (filterDot) filterDot.hidden = !filterActive;
        if (activeFilters) activeFilters.hidden = !filterActive;

        updateLoadMoreState(matchingCards.length, displayedCount);
      }

      function loadNextProductBatch() {
        if (!currentGrid || !currentLoadSentinel) return;
        const matchingCount = currentGrid.querySelectorAll('[data-tsp-product-card][data-tsp-filter-match="true"]').length;
        const cappedTotal = Math.min(matchingCount, maximumProductCount);
        if (loadedProductLimit >= cappedTotal) {
          updateLoadMoreState(matchingCount, cappedTotal);
          return;
        }

        if (currentLoadStatus) {
          currentLoadStatus.hidden = false;
          currentLoadStatus.textContent = 'Loading more styles…';
        }
        currentLoadSentinel.hidden = true;

        window.clearTimeout(loadMoreTimer);
        loadMoreTimer = window.setTimeout(() => {
          loadedProductLimit = Math.min(loadedProductLimit + loadBatchSize, maximumProductCount);
          applySortAndFilters();
          if (currentLoadStatus) currentLoadStatus.hidden = true;
        }, 120);
      }

      function setupInfiniteScroll() {
        if (loadMoreObserver) loadMoreObserver.disconnect();
        loadMoreObserver = null;

        if (!currentLoadSentinel || !('IntersectionObserver' in window)) return;

        loadMoreObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) loadNextProductBatch();
        }, {
          root: null,
          rootMargin: '600px 0px',
          threshold: 0.01
        });

        loadMoreObserver.observe(currentLoadSentinel);
      }

      function normalizedPath(url) {
        try {
          return new URL(url, window.location.origin).pathname.replace(/\/+$/, '') || '/';
        } catch (error) {
          return '';
        }
      }

      function findSelectionForUrl(url) {
        const targetPath = normalizedPath(url);
        if (!targetPath) return null;

        for (let categoryIndex = 0; categoryIndex < categoryConfigs.length; categoryIndex += 1) {
          const category = categoryConfigs[categoryIndex];
          const subcategories = Array.from(category.querySelectorAll('[data-tsp-subcategory-config]'));

          for (let subcategoryIndex = 0; subcategoryIndex < subcategories.length; subcategoryIndex += 1) {
            const subcategory = subcategories[subcategoryIndex];
            const collectionUrl = subcategory.dataset.collectionUrl || '';

            if (collectionUrl && normalizedPath(collectionUrl) === targetPath) {
              return {
                category,
                categoryIndex,
                subcategory,
                subcategoryIndex
              };
            }
          }
        }

        return null;
      }

      function updateCollectionUrl(config, mode = 'push') {
        if (!config || window.Shopify?.designMode) return;

        const collectionUrl = config.dataset.collectionUrl || '';
        if (!collectionUrl) return;

        const target = new URL(collectionUrl, window.location.origin);
        const current = new URL(window.location.href);

        target.search = '';
        target.hash = '';

        if (
          normalizedPath(target.href) === normalizedPath(current.href)
          && target.search === current.search
        ) {
          return;
        }

        const state = {
          ...(history.state || {}),
          tspCollectionUrl: target.pathname,
          tspBlockId: root.id
        };

        if (mode === 'replace') {
          history.replaceState(state, '', target.pathname);
        } else {
          history.pushState(state, '', target.pathname);
        }
      }

      function activateSubcategory(config, button, options = {}) {
        if (!config) return;
        subcategoryTrack?.querySelectorAll('[data-tsp-subcategory-button]').forEach((item) => {
          item.classList.toggle('is-active', item === button);
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });

        const productTemplate = config.querySelector('[data-tsp-products-template]');
        if (!productTemplate || !productsStage) return;
        productsStage.replaceChildren(productTemplate.content.cloneNode(true));
        currentProductList = productsStage.querySelector('[data-tsp-product-list]');
        currentGrid = productsStage.querySelector('[data-tsp-product-grid]');
        currentLoadSentinel = productsStage.querySelector('[data-tsp-load-more-sentinel]');
        currentLoadStatus = productsStage.querySelector('[data-tsp-load-more-status]');
        loadedProductLimit = initialProductCount;
        buildFilters();
        if (sortSelect) sortSelect.value = 'featured';
        if (inStockInput) inStockInput.checked = false;
        if (priceMinInput) priceMinInput.value = '';
        if (priceMaxInput) priceMaxInput.value = '';
        setupInfiniteScroll();
        applySortAndFilters();

        if (options.updateUrl !== false) {
          updateCollectionUrl(config, options.historyMode || 'push');
        }
      }

      function activateCategory(config, tabButton, options = {}) {
        if (!config || !subcategoryTrack) return;
        currentCategory = config;

        tabsHost?.querySelectorAll('.tsp-main-tab').forEach((button) => {
          const isActive = button === tabButton;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
          button.tabIndex = isActive ? 0 : -1;
        });

        restoreDescription(config);
        currentSubcategories = Array.from(config.querySelectorAll('[data-tsp-subcategory-config]'));
        subcategoryTrack.innerHTML = '';

        currentSubcategories.forEach((subcategory, index) => {
          const tileTemplate = subcategory.querySelector('[data-tsp-subcategory-tile-template]');
          if (!tileTemplate) return;
          const fragment = tileTemplate.content.cloneNode(true);
          const button = fragment.querySelector('[data-tsp-subcategory-button]');
          if (button) {
            button.dataset.subcategoryIndex = String(index);
            button.setAttribute('aria-pressed', 'false');
          }
          subcategoryTrack.appendChild(fragment);
        });

        let selectedIndex = Number.isInteger(options.subcategoryIndex)
          ? options.subcategoryIndex
          : currentSubcategories.findIndex((item) => item.dataset.defaultActive === 'true');

        if (selectedIndex < 0 || selectedIndex >= currentSubcategories.length) {
          selectedIndex = 0;
        }

        const selectedButton = subcategoryTrack.querySelector(`[data-subcategory-index="${selectedIndex}"]`)
          || subcategoryTrack.querySelector('[data-tsp-subcategory-button]');

        activateSubcategory(
          currentSubcategories[selectedIndex] || currentSubcategories[0],
          selectedButton,
          {
            updateUrl: options.updateUrl,
            historyMode: options.historyMode
          }
        );
      }

      function openFilters() {
        if (!filterDrawer) return;
        filterDrawer.hidden = false;
        document.body.classList.add('tsp-lock-scroll');
      }

      function closeFilters() {
        if (!filterDrawer) return;
        filterDrawer.hidden = true;
        if (quickBuy?.hidden !== false) document.body.classList.remove('tsp-lock-scroll');
      }

      function openQuickBuy(card) {
        const template = card?.querySelector('[data-tsp-quick-buy-template]');
        if (!template || !quickBuy || !quickBuyContent) return;
        quickBuyContent.replaceChildren(template.content.cloneNode(true));
        quickBuy.hidden = false;
        document.body.classList.add('tsp-lock-scroll');
      }

      function closeQuickBuy() {
        if (!quickBuy) return;
        quickBuy.hidden = true;
        quickBuyContent?.replaceChildren();
        if (filterDrawer?.hidden !== false) document.body.classList.remove('tsp-lock-scroll');
      }

      function selectedVariant(container) {
        const script = container.querySelector('[data-tsp-variants-json]');
        if (!script) return null;
        let variants = [];
        try {
          variants = JSON.parse(script.textContent);
        } catch (error) {
          return null;
        }

        const selectedOptions = Array.from(container.querySelectorAll('[data-option-index]')).map((fieldset) => {
          return fieldset.querySelector('.tsp-option-value.is-selected')?.dataset.tspOptionValue || '';
        });

        if (selectedOptions.length === 0) return variants[0] || null;
        return variants.find((variant) => {
          return selectedOptions.every((option, index) => variant.options?.[index] === option);
        }) || null;
      }

      function updateQuickBuyVariant(container) {
        const variant = selectedVariant(container);
        const variantInput = container.querySelector('[data-tsp-variant-id]');
        const currentPrice = container.querySelector('[data-tsp-current-price]');
        const comparePrice = container.querySelector('[data-tsp-compare-price]');
        const submit = container.querySelector('[data-tsp-quick-buy-submit]');
        const moneyFormat = root.dataset.moneyFormat;

        if (!variant) {
          if (submit) {
            submit.disabled = true;
            submit.textContent = 'UNAVAILABLE';
          }
          return;
        }

        if (variantInput) variantInput.value = variant.id;
        if (currentPrice) {
          currentPrice.innerHTML = formatMoney(variant.price, moneyFormat);
          currentPrice.classList.toggle('is-sale', Number(variant.compare_at_price || 0) > Number(variant.price));
        }
        if (comparePrice) {
          const hasCompare = Number(variant.compare_at_price || 0) > Number(variant.price);
          comparePrice.hidden = !hasCompare;
          comparePrice.innerHTML = hasCompare ? formatMoney(variant.compare_at_price, moneyFormat) : '';
        }
        if (submit) {
          submit.disabled = !variant.available;
          submit.textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT';
        }
      }

      async function addToCart(form) {
        const variantId = form.querySelector('[data-tsp-variant-id]')?.value;
        const status = form.querySelector('[data-tsp-quick-buy-status]');
        const submit = form.querySelector('[data-tsp-quick-buy-submit]');
        if (!variantId || !submit) return;

        submit.disabled = true;
        submit.textContent = 'ADDING…';
        if (status) status.textContent = '';

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
          });

          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Unable to add this item.');

          if (status) status.textContent = 'Added to bag.';
          submit.textContent = 'ADDED';

          try {
            const cartResponse = await fetch(root.dataset.cartUrl, { headers: { Accept: 'application/json' } });
            const cart = await cartResponse.json();
            document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"]').forEach((node) => {
              node.textContent = String(cart.item_count);
            });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
          } catch (cartError) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }

          window.setTimeout(closeQuickBuy, 700);
        } catch (error) {
          if (status) status.textContent = error.message || 'Unable to add this item.';
          submit.disabled = false;
          submit.textContent = 'ADD TO BAG';
        }
      }

      function mobileMenuIsOpen() {
        return Boolean(document.querySelector(
          '.menu-drawer-container[open], details[open] .menu-drawer, .menu-drawer[aria-hidden="false"], [data-menu-drawer].is-open, [data-mobile-menu].is-open'
        ));
      }

      function syncMobileMenu() {
        root.classList.toggle('is-mobile-menu-open', mobileMenuIsOpen());
      }

      root.addEventListener('click', (event) => {
        const mainTab = event.target.closest('.tsp-main-tab');
        if (mainTab && tabsHost?.contains(mainTab)) {
          const config = categoryConfigs[Number(mainTab.dataset.categoryIndex)];
          activateCategory(config, mainTab);
          return;
        }

        const subcategoryButton = event.target.closest('[data-tsp-subcategory-button]');
        if (subcategoryButton && subcategoryTrack?.contains(subcategoryButton)) {
          event.preventDefault();
          const config = currentSubcategories[Number(subcategoryButton.dataset.subcategoryIndex)];
          activateSubcategory(config, subcategoryButton);
          return;
        }

        if (event.target.closest('[data-tsp-filter-open]')) {
          openFilters();
          return;
        }

        if (event.target.closest('[data-tsp-filter-close]')) {
          closeFilters();
          return;
        }

        if (event.target.closest('[data-tsp-clear-filters]')) {
          resetFilters();
          return;
        }

        const quickBuyOpen = event.target.closest('[data-tsp-quick-buy-open]');
        if (quickBuyOpen) {
          event.preventDefault();
          openQuickBuy(quickBuyOpen.closest('[data-tsp-product-card]'));
          return;
        }

        if (event.target.closest('[data-tsp-quick-buy-close]')) {
          closeQuickBuy();
          return;
        }

        const option = event.target.closest('[data-tsp-option-value]');
        if (option) {
          const fieldset = option.closest('[data-option-index]');
          fieldset?.querySelectorAll('[data-tsp-option-value]').forEach((button) => {
            button.classList.toggle('is-selected', button === option);
          });
          const container = option.closest('[data-tsp-quick-buy-product]');
          if (container) updateQuickBuyVariant(container);
        }
      });

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-tsp-sort], [data-tsp-in-stock], [data-tsp-facet-filter], [data-tsp-price-min], [data-tsp-price-max]')) {
          loadedProductLimit = initialProductCount;
          applySortAndFilters();
        }
      });

      root.addEventListener('input', (event) => {
        if (event.target.matches('[data-tsp-price-min], [data-tsp-price-max]')) {
          loadedProductLimit = initialProductCount;
          applySortAndFilters();
        }
      });

      root.addEventListener('submit', (event) => {
        const form = event.target.closest('[data-tsp-quick-buy-form]');
        if (!form) return;
        event.preventDefault();
        addToCart(form);
      });

      buildTabs();

      const urlSelection = findSelectionForUrl(window.location.href);
      const defaultCategoryIndex = Math.max(
        0,
        categoryConfigs.findIndex((config) => config.dataset.defaultActive === 'true')
      );
      const initialCategoryIndex = urlSelection?.categoryIndex ?? defaultCategoryIndex;
      const initialTab = tabsHost?.querySelector(`[data-category-index="${initialCategoryIndex}"]`)
        || tabsHost?.querySelector('.tsp-main-tab');

      activateCategory(
        categoryConfigs[initialCategoryIndex] || categoryConfigs[0],
        initialTab,
        {
          subcategoryIndex: urlSelection?.subcategoryIndex,
          updateUrl: false
        }
      );

      window.addEventListener('popstate', () => {
        const selection = findSelectionForUrl(window.location.href);

        if (selection) {
          const tab = tabsHost?.querySelector(`[data-category-index="${selection.categoryIndex}"]`);
          activateCategory(selection.category, tab, {
            subcategoryIndex: selection.subcategoryIndex,
            updateUrl: false
          });
          return;
        }

        const fallbackTab = tabsHost?.querySelector(`[data-category-index="${defaultCategoryIndex}"]`)
          || tabsHost?.querySelector('.tsp-main-tab');

        activateCategory(
          categoryConfigs[defaultCategoryIndex] || categoryConfigs[0],
          fallbackTab,
          { updateUrl: false }
        );
      });

      syncMobileMenu();

      const observer = new MutationObserver(syncMobileMenu);
      observer.observe(document.body, {
        subtree: true,
        attributes: true,
        attributeFilter: ['open', 'class', 'aria-hidden']
      });
    }

    function initialiseAll(scope = document) {
      scope.querySelectorAll(ROOT_SELECTOR).forEach(initialise);
      if (scope.matches?.(ROOT_SELECTOR)) initialise(scope);
    }

    initialiseAll();
    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
    document.addEventListener('shopify:block:load', (event) => initialiseAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
